import categoryTax from "../../../../assets/img/ask-category-tax.svg";
import categoryFinance from "../../../../assets/img/ask-category-finance.svg";
import categorySocialSecurity from "../../../../assets/img/ask-category-social_security.svg";
import categoryAccounting from "../../../../assets/img/ask-category-accounting.svg";
import categoryContract from "../../../../assets/img/ask-category-contract.svg";
import categoryCorporate from "../../../../assets/img/ask-category-corporate.svg";
import categoryTaxRelief from "../../../../assets/img/ask-category-tax_relief.svg";
import categoryOther from "../../../../assets/img/ask-category-other.svg";

const CategoryImg = category => {

  let categoryImg;

  switch (category){
  case "tax":
    categoryImg = categoryTax;
    break;
  case "finance":
    categoryImg = categoryFinance;
    break;
  case "social_security":
    categoryImg = categorySocialSecurity;
    break;
  case "accounting":
    categoryImg = categoryAccounting;
    break;
  case "contract":
    categoryImg = categoryContract;
    break;
  case "corporate":
    categoryImg = categoryCorporate;
    break;
  case "tax_relief":
    categoryImg = categoryTaxRelief;
    break;
  default:
    categoryImg = categoryOther;
    break;
  }

  return categoryImg;

};

export default CategoryImg;